import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import Header from '../../UI/Header/Header';
import {centeredFlex, headerHeight, fontSize, tabletWidth} from '../../mixins';
import Email from './Email';
import Social from './Social';
import Terms from './Terms';
import {useDispatch, useSelector} from 'react-redux';
import {selectToken, sendSocialLoginRequest, setUserUuid} from './authSlice';
import {getFireBaseInfo, isTimestampExpired, queryParser, removeFireBaseData} from '../../common/helper';
import {selectLoginError, setError} from '../error/errorSlice';
import MagicLink from './MagicLink';
import Cookies from 'js-cookie';
import LoginError from '../error/LoginError';
const OLDER_THAN_24H = 8.64e+7; //24h in ms


const StyledContainer = styled.div`
  ${centeredFlex};
  height: calc(100% - ${headerHeight});
  padding-top: calc(${headerHeight} + 1vh);
  padding-left: 6px;
  padding-right: 6px;
`;

const StyledUpperBlock = styled.div`
  height: 70%;
  max-height: 700px;
  min-height: 600px;
  margin-bottom: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const StyledTitle = styled.h1`
  font-weight: 700;
  ${fontSize(26)};
  line-height: 33px;
  text-align: center;
  color: #323232;
  mix-blend-mode: normal;
  margin: 0;
  
  @media screen and (max-width: 374px) {
    margin: 0;
    ${fontSize(20)};
  }
  
  @media screen and (min-width: ${tabletWidth}) {
      ${fontSize(34)};
  }
`;


const Auth = ({history, database}) => {
    const dispatch = useDispatch();
    const token = useSelector(selectToken);
    const loginError = useSelector(selectLoginError);
    const [pseudoID, setPseudoID] = useState(null);
    const [firebaseData, setFirebaseData] = useState(null);

    useEffect(() => {
        let userUuid = Cookies.get('userUuid');
        if (userUuid) dispatch(setUserUuid(userUuid));
    },[dispatch]);

    const errorHandler = () => dispatch(setError({show: true, type: 'magicLogin', text: 'Invalid link. Please, try a new one'}));

    const getPseudoToken = (database, id, cb) => {
        getFireBaseInfo(database, '/login/', id, cb, errorHandler);
    };

    const sendPseudoLoginRequest = () => {
        const params = {access_token: firebaseData.token, driver: 'magic_link'};

        if (!isTimestampExpired(firebaseData.creation_time, OLDER_THAN_24H)) {
            console.log(firebaseData.creation_time);
            dispatch(sendSocialLoginRequest(params));
            removeFireBaseData(database, '/login/', pseudoID);
        } else {
            console.log(firebaseData.creation_time);
            dispatch(setError({show: true, type: 'pseudoLogin', text: 'Your magic link got expired.'}));
        }
    };

    useEffect(() => {
        if (history.location.search) {
            const magicID = queryParser(history.location.search);
            setPseudoID(magicID.id);
        }
    }, [history]);

    useEffect(() => {
        pseudoID && getPseudoToken(database, pseudoID, setFirebaseData);
    }, [pseudoID]);

    useEffect(() => {
        if (firebaseData) {
            sendPseudoLoginRequest();
        }
    }, [firebaseData]);


    useEffect(() => {
        if (!!token) {
            history.push('/signing-in');
        }

    }, [token]);
    return (
        <>
            <Header bgColor={'#fff'}/>
            <StyledContainer>
                <StyledUpperBlock>
                    {loginError && <LoginError />}
                    <StyledTitle>Welcome back to Geozilla!</StyledTitle>
                    <Email/>
                    <Social/>
                </StyledUpperBlock>
                <MagicLink/>
                <Terms/>
            </StyledContainer>
        </>
    );
};


export default Auth;